import { hdmgdjGenres } from "@/mocks/hdmgdj/genres";

export default function HdmgdjGenres() {
  return (
    <section id="hdmgdj-genres" className="w-full bg-background-100 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-accent-600 text-[14px] font-label font-bold">
              <i className="ri-fire-line text-lg" />
              热门题材
            </span>
            <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[44px] leading-tight">
              六大赛道，总有一部让你
              <span className="text-accent-600"> 上头</span>
            </h2>
          </div>
          <p className="text-[15px] leading-7 text-foreground-600 md:max-w-sm">
            都市逆袭、国风古装、悬疑烧脑、沙雕搞笑、甜宠恋爱、玄幻修仙，每日爆更不断档。
          </p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {hdmgdjGenres.map((genre, index) => (
            <div
              key={genre.id}
              className="hdmgdj-reveal group relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-foreground-950"
              style={{ transitionDelay: `${(index % 6) * 50}ms` }}
            >
              <img
                src={genre.image}
                alt={`黄豆魔改短剧题材-${genre.name}`}
                title={`黄豆魔改短剧-${genre.name}`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 hdmgdj-card-shade" />
              <span className="absolute left-3 top-3 inline-flex items-center h-7 px-2.5 rounded-md bg-background-50/20 text-[11px] font-label text-background-50">
                {index + 1 < 10 ? `0${index + 1}` : index + 1}
              </span>
              <div className="absolute left-0 right-0 bottom-0 p-3">
                <p className="text-[15px] font-bold font-label text-background-50">{genre.name}</p>
                <p className="mt-1 text-[12px] font-label text-primary-300">{genre.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}